import { localStorage } from '@muse-web/storages'

import { ANALYTICS_TRIGGER_KEY } from '../constants/storageKeys'

const TTL = 30 * 60 * 1000 // 30 minutes

type TStoredValue = {
    value: string
    timestamp: number
}

export const setAnalyticsTrigger = (value: string) => {
    localStorage.set(ANALYTICS_TRIGGER_KEY, { value, timestamp: Date.now() })
}

export const getAnalyticsTrigger = (): string | null => {
    const item = localStorage.get(ANALYTICS_TRIGGER_KEY) as TStoredValue | null
    if (!item) {
        return null
    }

    const isExpired = Date.now() - item.timestamp > TTL
    if (isExpired) {
        localStorage.remove(ANALYTICS_TRIGGER_KEY)
        return null
    }

    return item.value
}
